<template>
  <div class="close-circle-button-modal__cover" @click.self="onClickModalCover">
    <div class="close-circle-button-modal__content">
      <div class="close-circle-button-modal__header">
        <CloseCircleOutline
          class="close-circle-button-modal__close-icon"
          @click="onClickCloseButton"
        />
        <span>{{ titleText }}</span>
      </div>
      <div class="close-circle-button-modal__body">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import CloseCircleOutline from '../../atoms/svg_icons/CloseCircleOutline.vue'

export default {
  name: 'CloseCircleButtonModal',
  components: {
    CloseCircleOutline
  },
  props: {
    titleText: {
      type: String,
      required: true
    }
  },
  methods: {
    onClickModalCover() {
      this.$emit('clicked-modal-cover')
    },
    onClickCloseButton() {
      this.$emit('clicked-close')
    }
  }
}
</script>

<style lang="scss" scoped>
.close-circle-button-modal {
  &__cover {
    // TODO: z-index 全体を管理する際に適切なファイル、値にする
    // header が 100 なので 101 をセットする
    z-index: 101;
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 92%;
    padding: 0 4%;
    background-color: $dark_black_cover;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow-y: auto;
  }

  &__content {
    background: $white;
    border-radius: 8px;
    text-align: center;
    width: 100%;
    max-width: 375px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  &__header {
    @extend %body-bold;
    padding: 24px 24px 16px 24px;
    display: flex;
    align-items: center;
    gap: 8px;
    border-bottom: solid $gray-1 1px;
  }

  &__close-icon {
    cursor: pointer;
    width: 24px;
    height: 24px;
  }

  &__body {
    padding: 16px 24px 24px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    text-align: left;
  }
}
</style>
